import { Box, ListItem, Skeleton, Stack } from '@mui/material';

import usePrimaryNavStore from '@/components/shared/PrimaryNavDrawer/PrimaryNavStore';

const PrimaryNavClientCardSkeleton = () => {
  const { isDrawerOpen } = usePrimaryNavStore();

  return (
    <Box
      sx={{
        height: '56px',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <ListItem
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: isDrawerOpen ? 'space-between' : 'center',
        }}
      >
        <Stack
          direction="row"
          spacing={isDrawerOpen ? 0.5 : 0}
          sx={{
            alignItems: 'center',
            height: '56px',
            flex: 1,
            p: 1,
            border: isDrawerOpen ? '1px solid #404E57' : 'none',
            borderRadius: isDrawerOpen ? '30px' : '0',
          }}
        >
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            sx={{
              bgcolor: 'neutral600',
            }}
          />
          {isDrawerOpen && (
            <Stack>
              <Skeleton
                variant="text"
                width={200}
                height={20}
                sx={{
                  bgcolor: 'neutral600',
                }}
              />
              <Skeleton
                variant="text"
                width={100}
                height={16}
                sx={{
                  bgcolor: 'neutral600',
                }}
              />
            </Stack>
          )}
        </Stack>
      </ListItem>
    </Box>
  );
};

export default PrimaryNavClientCardSkeleton;
